<aux-button
  variant="hyperlink"
  #trigger="cdkOverlayOrigin"
  cdkOverlayOrigin
  [disabled]="!optionalFilters.length"
  (clickEmit)="!!optionalFilters.length && toggleOpenList(!isOpen)"
  (auxClickOutside)="toggleOpenList(false)"
  label="+ Add Filter"
/>
<ng-template
  cdkConnectedOverlay
  class="border-solid border-aux-gray-dark-100"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
>
  <ul
    tabindex="-1"
    class="mt-2 w-56 overflow-auto rounded border border-aux-gray-dark bg-white text-base"
  >
    @for (filter of optionalFilters; track filter; let index = $index) {
      <ng-container class="grid">
        <li
          class="relative flex cursor-pointer select-none flex-col p-2.5 text-gray-900 hover:bg-aux-gray-light"
          (click)="selectFilter(filter)"
        >
          <p class="font-inter">
            {{ filter }}
          </p>
        </li>
      </ng-container>
    }
  </ul>
</ng-template>
